import Vue from "vue";
import round from "lodash/round";
import get from "lodash/fp/get";

const LOCALE_MAP = {
  THB: "th-TH",
};

export default Vue.extend({
  computed: {
    currencySign() {
      const locale = get("config.locale", window) || "US";
      const currency =
        get("listing.get_currency", this) ||
        get("config.currency", window) ||
        "USD";
      const currLocale = LOCALE_MAP[currency] || `en-${locale}`;
      const curr = new Intl.NumberFormat(currLocale, {
        style: "currency",
        currency,
        maximumFractionDigits: 0,
      });
      return curr.formatToParts(0).find((c) => c.type === "currency")?.value;
    },
  },
  methods: {
    getCurrencySymbol(code, locale = "en") {
      const formatted = new Intl.NumberFormat(locale, {
        style: "currency",
        currency: code,
        currencyDisplay: "narrowSymbol",
      }).format(0);
      return formatted.replace(/[\d.,\s]/g, "");
    },
    commaList(list: string[]): string {
      return list.join(", ");
    },
    toMoney(num, decimal = 2, currency = "$") {
      return `${currency}${round(num, decimal).toLocaleString()}`;
    },
    parseDate(date, format = "DD MMM YYYY", config = { local: true }) {
      const parsedDate = config?.local
        ? this.$moment(date)
        : this.$moment.utc(date);
      if (parsedDate) {
        return parsedDate.format(format);
      }
    },
    daysDifference([startDate, endDate]): number {
      return this.$moment
        .utc(endDate)
        .diff(this.$moment.utc(startDate), "days");
    },
    filtersDateRange([startDate, endDate]) {
      const [startDay, endDay] = [
        startDate.split(" ")[0],
        endDate.split(" ")[0],
      ];
      const [startMonth, endMonth] = [
        startDate.split(" ")[1],
        endDate.split(" ")[1],
      ];
      if (startMonth === endMonth)
        return `${startDay} - ${endDay} ${startMonth}`;
      else return `${startDate} - ${endDate}`;
    },
    cutText(text, limit) {
      return text.length >= limit ? `${text.substring(0, limit)}...` : text;
    },
    /**
     * Convert and format an amount to the selected currency using the rate from settings/localStorage.
     * @param {number} amount - The base price in default currency (e.g. USD)
     * @param {object} settings - The settings object containing currencies
     * @returns {string} - Formatted price string
     */
    toDisplayCurrency(amount, settings, fromCurrency) {
      const selectedCurrency =
        localStorage.getItem("selectedCurrency") ||
        get("listing.get_currency", this) ||
        fromCurrency ||
        "USD";
      const currencies = (settings && settings.currencies) || [];
      const converted =
        amount *
        currencies[fromCurrency || get("listing.get_currency", this)][
          selectedCurrency
        ];
      // Format with 0 decimals for most currencies, 2 for others
      return `${this.getCurrencySymbol(
        selectedCurrency
      )}${converted.toLocaleString(undefined, {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      })}`;
    },
  },
});
